export * from './externalLinks';
export * from './menus';
export * from './routes';
export * from './translations';

export const SUPPORTED_LANGUAGES = ['en', 'in', 'jp', 'fi'];
